<!-- 我的快递 -->
<template>
  <div :class="['myExpress', { inApp: $root.$data.isApp||this.$root.miniprogram,yt:$root.ytMini }]">
    <template v-if="loadingTip">
      <van-loading
        size="24px"
        vertical
      >加载中...</van-loading>
    </template>
    <template v-else>
      <common-title
        titleName="我的快递"
        :bcColor="'#fafafa'"
        :zIndex="1000"
      ></common-title>
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        :disabled="disabled"
      >
        <section>
          <!-- 最近发货 -->
          <RecentLogistics
            :deliver="deliver"
            @setDisabled="setDisabled"
          />
          <!-- 讲义列表 -->
          <section v-show="!isEmpty">
            <h1 class="handout-title">我的讲义</h1>
            <van-list
              v-model="loading"
              :finished="finished"
              :immediate-check="false"
              @load="onLoad"
            >
              <ul class="handout-list">
                <li
                  v-for="(item, index) in handList"
                  :key="index"
                >
                  <h3 class="order-time">订单时间：{{ item.payTime.slice(0, 16) }}</h3>
                  <HandoutCard
                    v-for="(list, index) in item.productRespVOS"
                    :key="index"
                    :info="list"
                    @setDisabled="setDisabled"
                  />
                </li>
              </ul>
            </van-list>
          </section>
        </section>
      </van-pull-refresh>
      <!-- <Foot /> -->
      <EmptyData
        v-show="isEmpty"
        :emptyName="'toHandout'"
      />
      <footer
        class="foot"
        @click="modifyAddress"
      >
        <p>修改收货地址</p>
      </footer>
    </template>
  </div>
</template>

<script>
import { reqHandoutList, reqWaitDeliver, reqLatelyDeliver } from '@/api/personal/logistics/index';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
// import Foot from '@/components/foot/privacy.vue';
import RecentLogistics from './component/recentLogistics.vue';
import HandoutCard from './component/handoutCard.vue';

export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      handList: [], // 讲义列表
      loading: false,
      finished: false,
      refreshing: false,
      wiatNum: 0,
      isEmpty: false,
      deliver: {},
      disabled: false,
      loadingTip: true,
    };
  },

  components: {
    CommonTitle,
    RecentLogistics,
    HandoutCard,
    EmptyData,
    // Foot,
  },

  computed: {},

  mounted() {
    document.title = '我的快递';
  },

  created() {
    this.getHandoutList(this.pageNum, this.pageSize);
    this.getWaitDeliver();
    this.getRecent();
  },

  methods: {
    setDisabled(data) {
      this.disabled = data;
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = true;
      this.pageNum = 1;
      this.finished = false;
      this.getHandoutList(this.pageNum, this.pageSize);
      this.getRecent();
    },
    onLoad() {
      this.pageNum += 1;
      this.getHandoutList(this.pageNum, this.pageSize);
    },
    async getRecent() {
      const { code, data } = await reqLatelyDeliver();
      if (code === 0 && data) {
        this.deliver = data;
      }
       this.loadingTip = false;
    },
    async getHandoutList(pageNum, pageSize) {
      const { code, data } = await reqHandoutList(pageNum, pageSize);
      if (code === 0) {
        if (this.refreshing) {
          this.handList = [];
        }
        this.refreshing = false;
        this.loading = false;
        this.handList = [...this.handList, ...data.data];
        if (!data.data.length) {
          this.finished = true;
        }
      }
      this.isEmpty = !this.handList.length;
    },
    async getWaitDeliver() {
      const { code, data } = await reqWaitDeliver();
      if (code === 0) {
        this.loadingTip = false;
        this.wiatNum = data;
      }
    },
    modifyAddress() {
      if (this.wiatNum) {
        this.$dialog
          .confirm({
            confirmButtonText: '前往修改',
            confirmButtonColor: '#FF6C02',
            message: `目前有${this.wiatNum}本讲义代发货，操作修改地址后将修改所有讲义的地址`,
          })
          .then(() => {
            this.$router.push({
              path: 'address',
              query: {
                sourse: 1,
              },
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$dialog.alert({
          confirmButtonText: '好的',
          confirmButtonColor: '#FF6C02',
          message: '目前没有讲义待发货，无需修改收货地址',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.myExpress.yt{
  ::v-deep .express .express-name button{
    background: linear-gradient( 180deg, #FFAC80 0%, #FF3F29 100%);
  }
  ::v-deep .card .flag b{
       background: linear-gradient( 180deg, #FFAC80 0%, #FF3F29 100%);
 
  }
  .foot p{
    background: #FF3F29;
  }
}
.myExpress {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #f9f9f9;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  section {
    // min-height: 500px;
    padding: 0 0 40px 0;
  }
  .handout-title {
    padding: 40px 0 0 40px;
    color: #333;
    font-weight: 600;
    font-size: 36px;
  }
  .handout-list {
    padding: 40px;
    li {
      .order-time {
        color: #787878;
        font-size: 26px;
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 98px;
    background: #fff;
    p {
      width: 670px;
      height: 72px;
      margin: 13px auto;
      color: #fff;
      font-size: 28px;
      line-height: 72px;
      text-align: center;
      background: #ff6c02;
      border-radius: 40px;
    }
  }
}
::v-deep .emptyIndent div,
::v-deep .emptyIndent div img {
  width: 388px;
  //   height: 152px;
  margin: 0 0 64px 0;
}
::v-deep .common-foot {
  position: relative;
  z-index: 0;
}
</style>
